<label class="switch {{klass}}">
  <input type="checkbox" [checked]="checked" (change)="toggle()">
  <span class="slider"></span>
</label>
